import { REQUEST_USER_BALANCE, RECEIVE_USER_BALANCE, FAILURE_USER_BALANCE } from './constants';

import { CALL_API } from '../../../middlewares/api';

export function fetchUserBalance() {
    return {
        [CALL_API]: {
            endpoint: '/ebon/credit',
            types: [REQUEST_USER_BALANCE, RECEIVE_USER_BALANCE, FAILURE_USER_BALANCE]
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/balance/actions.js